import { Controller, useFormContext } from 'react-hook-form';

import { Input } from '@/ui/TextField';
import { FormSchema } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoLinkModal';
import { isValidEmbedVideoUrl } from '@/component/customEditorV2/ui/elements/Video/hooks/useVideoUploadProgress';

export const ViewPracticalAssessmentVideoLinkForm = (): JSX.Element => {
  const { control } = useFormContext<FormSchema>();

  return (
    <Controller
      control={control}
      rules={{ required: true, validate: (text) => isValidEmbedVideoUrl(text) }}
      name={'link'}
      render={({ field: { onChange: onLinkChange, name, value: linkValue }, fieldState: { error } }) => (
        <Input
          onChange={onLinkChange}
          name={name}
          value={linkValue || ''}
          leadingIcon="link"
          fullWidth
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          label="Link"
          helperText="Only YouTube, Ted, Creo/Avalon One, Vimeo, and Microsoft videos"
          error={
            error && {
              message: 'Only YouTube, Ted, Creo/Avalon One, Vimeo and Microsoft videos',
            }
          }
        />
      )}
    />
  );
};
